import { render } from "./BanerVideo.vue?vue&type=template&id=ade593dc&scoped=true"
import script from "./BanerVideo.vue?vue&type=script&lang=js"
export * from "./BanerVideo.vue?vue&type=script&lang=js"

import "./BanerVideo.vue?vue&type=style&index=0&id=ade593dc&lang=scss&scoped=true"

import exportComponent from "C:\\GoogleDrive\\Projects\\Vue\\_published\\ksaien\\ksaien\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ade593dc"]])

export default __exports__